// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "gift_card_transaction".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { giftCardTransactionTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "gift_card_transaction" table (1:1 with a DB row, on the wire). */
export const giftCardTransactionAtomSchema = z.object({
    id: z.string(),
    giftCardId: z.string(),
    type: z.enum(giftCardTransactionTypeValues),
    amountCents: z.number(),
    saleId: z.string().nullable(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=giftCardTransaction.js.map